require("style-loader!css-loader!less-loader!./font-awesome-styles.loader.js!./font-awesome.config.js");
